module.exports = __webpack_public_path__ + "media/images/emblems/Renan-coat_of_arms-09aac0ca789a47910eb18b6495585f88.svg";